var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEnvelop = function SvgEnvelop(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1060_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 17.5H45V20C45 20.663 45.2634 21.2989 45.7322 21.7678C46.2011 22.2366 46.837 22.5 47.5 22.5C48.163 22.5 48.7989 22.2366 49.2678 21.7678C49.7366 21.2989 50 20.663 50 20V17.5H52.5C53.163 17.5 53.7989 17.2366 54.2678 16.7678C54.7366 16.2989 55 15.663 55 15C55 14.337 54.7366 13.7011 54.2678 13.2322C53.7989 12.7634 53.163 12.5 52.5 12.5H50V10C50 9.33696 49.7366 8.70107 49.2678 8.23223C48.7989 7.76339 48.163 7.5 47.5 7.5C46.837 7.5 46.2011 7.76339 45.7322 8.23223C45.2634 8.70107 45 9.33696 45 10V12.5H42.5C41.837 12.5 41.2011 12.7634 40.7322 13.2322C40.2634 13.7011 40 14.337 40 15C40 15.663 40.2634 16.2989 40.7322 16.7678C41.2011 17.2366 41.837 17.5 42.5 17.5ZM52.5 27.5C51.837 27.5 51.2011 27.7634 50.7322 28.2322C50.2634 28.7011 50 29.337 50 30V45C50 45.663 49.7366 46.2989 49.2678 46.7678C48.7989 47.2366 48.163 47.5 47.5 47.5H12.5C11.837 47.5 11.2011 47.2366 10.7322 46.7678C10.2634 46.2989 10 45.663 10 45V21.025L24.7 35.75C26.1063 37.1545 28.0125 37.9434 30 37.9434C31.9875 37.9434 33.8937 37.1545 35.3 35.75L41.475 29.575C41.9458 29.1042 42.2102 28.4658 42.2102 27.8C42.2102 27.1342 41.9458 26.4958 41.475 26.025C41.0042 25.5542 40.3658 25.2898 39.7 25.2898C39.0342 25.2898 38.3958 25.5542 37.925 26.025L31.75 32.2C31.2827 32.6581 30.6544 32.9146 30 32.9146C29.3456 32.9146 28.7173 32.6581 28.25 32.2L13.525 17.5H32.5C33.163 17.5 33.7989 17.2366 34.2678 16.7678C34.7366 16.2989 35 15.663 35 15C35 14.337 34.7366 13.7011 34.2678 13.2322C33.7989 12.7634 33.163 12.5 32.5 12.5H12.5C10.5109 12.5 8.60322 13.2902 7.1967 14.6967C5.79018 16.1032 5 18.0109 5 20V45C5 46.9891 5.79018 48.8968 7.1967 50.3033C8.60322 51.7098 10.5109 52.5 12.5 52.5H47.5C49.4891 52.5 51.3968 51.7098 52.8033 50.3033C54.2098 48.8968 55 46.9891 55 45V30C55 29.337 54.7366 28.7011 54.2678 28.2322C53.7989 27.7634 53.163 27.5 52.5 27.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1060_324",
    x: -1,
    y: 0,
    width: 62,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1060_324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1060_324",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelop.0289fabc.svg";
export { ForwardRef as ReactComponent };